import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TextField } from '@mui/material';

export default function OrderFormItemDescriptionField({
  formItemId,
  committedDescription,
  disabled,
  placeholder,
  sx,
  onDraftInput,
  onCommit,
}) {
  const inputRef = useRef(null);
  const focusedRef = useRef(false);
  const [text, setText] = useState(() =>
    committedDescription == null ? '' : String(committedDescription),
  );

  useEffect(() => {
    if (focusedRef.current) return;
    const next = committedDescription == null ? '' : String(committedDescription);
    setText((prev) => (prev === next ? prev : next));
  }, [committedDescription]);

  const handleChange = useCallback(
    (e) => {
      const v = e.target.value;
      setText(v);
      onDraftInput(formItemId, v);
    },
    [formItemId, onDraftInput],
  );

  const handleFocus = useCallback(() => {
    focusedRef.current = true;
  }, []);

  const handleBlur = useCallback(() => {
    focusedRef.current = false;
    onCommit(formItemId, text);
  }, [formItemId, text, onCommit]);

  return (
    <TextField
      inputRef={inputRef}
      size="small"
      placeholder={placeholder}
      value={text}
      disabled={disabled}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      multiline
      minRows={1}
      maxRows={4}
      sx={[
        sx,
        {
          '& .MuiInputBase-root': {
            alignItems: 'flex-start',
          },
          '& .MuiInputBase-inputMultiline': {
            py: { xs: '8px', md: '8px' },
            px: { xs: '11px', md: '10px' },
            lineHeight: 1.43,
          },
        },
      ]}
    />
  );
}
